const provinceCoordinates = {
  "กระบี่": [8.0863, 98.9063],
  "กรุงเทพมหานคร": [13.736717, 100.523186],
  "กาญจนบุรี": [14.0228, 99.5328],
  "กาฬสินธุ์": [16.4313, 103.5060],
  "กำแพงเพชร": [16.4834, 99.5226],
  "ขอนแก่น": [16.4322, 102.8236],
  "จันทบุรี": [12.6112, 102.1039],
  "ฉะเชิงเทรา": [13.6880, 101.0721],
  "ชลบุรี": [13.3611, 100.9847],
  "ชัยนาท": [15.1860, 100.1253],
  "ชัยภูมิ": [15.8069, 102.0315],
  "ชุมพร": [10.4931, 99.1800],
  "เชียงราย": [19.9105, 99.8406],
  "เชียงใหม่": [18.7883, 98.9853],
  "ตรัง": [7.5567, 99.6117],
  "ตราด": [12.2436, 102.5180],
  "ตาก": [16.8835, 99.1280],
  "นครนายก": [14.2066, 101.2131],
  "นครปฐม": [13.8199, 100.0621],
  "นครพนม": [17.4017, 104.7922],
  "นครราชสีมา": [14.9799, 102.0977],
  "นครศรีธรรมราช": [8.4304, 99.9631],
  "นครสวรรค์": [15.7050, 100.1365],
  "นนทบุรี": [13.8608, 100.5141],
  "นราธิวาส": [6.4264, 101.8233],
  "น่าน": [18.7832, 100.7782],
  "บึงกาฬ": [18.3609, 103.6465],
  "บุรีรัมย์": [14.9930, 103.1036],
  "ปทุมธานี": [14.0208, 100.5250],
  "ประจวบคีรีขันธ์": [11.8130, 99.7976],
  "ปราจีนบุรี": [14.0421, 101.6608],
  "ปัตตานี": [6.8691, 101.2501],
  "พระนครศรีอยุธยา": [14.3692, 100.5877],
  "พังงา": [8.4501, 98.5250],
  "พัทลุง": [7.6167, 100.0833],
  "พิจิตร": [16.4409, 100.3486],
  "พิษณุโลก": [16.8288, 100.2729],
  "เพชรบุรี": [13.1117, 99.9447],
  "เพชรบูรณ์": [16.4190, 101.1606],
  "แพร่": [18.1446, 100.1403],
  "ภูเก็ต": [7.8804, 98.3923],
  "มหาสารคาม": [16.1805, 103.3006],
  "มุกดาหาร": [16.5453, 104.7234],
  "แม่ฮ่องสอน": [19.3020, 97.9654],
  "ยะลา": [6.5400, 101.2800],
  "ยโสธร": [15.7941, 104.1453],
  "ร้อยเอ็ด": [16.0514, 103.6539],
  "ระนอง": [9.9604, 98.6384],
  "ระยอง": [12.6814, 101.2775],
  "ราชบุรี": [13.5360, 99.8171],
  "ลพบุรี": [14.7995, 100.6534],
  "ลำปาง": [18.2888, 99.4901],
  "ลำพูน": [18.5732, 99.0087],
  "เลย": [17.4860, 101.7222],
  "ศรีสะเกษ": [15.1186, 104.3223],
  "สกลนคร": [17.1693, 104.1445],
  "สงขลา": [7.1907, 100.5952],
  "สตูล": [6.6238, 100.0673],
  "สมุทรปราการ": [13.5991, 100.5962],
  "สมุทรสงคราม": [13.4146, 100.0023],
  "สมุทรสาคร": [13.5475, 100.2744],
  "สระบุรี": [14.5289, 100.9100],
  "สระแก้ว": [13.8240, 102.0646],
  "สิงห์บุรี": [14.8879, 100.4050],
  "สุโขทัย": [17.0078, 99.8220],
  "สุพรรณบุรี": [14.4745, 100.1226],
  "สุราษฎร์ธานี": [9.1400, 99.3330],
  "สุรินทร์": [14.8819, 103.4936],
  "หนองคาย": [17.8785, 102.7420],
  "หนองบัวลำภู": [17.1893, 102.8557],
  "อำนาจเจริญ": [15.8582, 104.6258],
  "อุดรธานี": [17.4138, 102.7872],
  "อุตรดิตถ์": [17.6200, 100.0997],
  "อุทัยธานี": [15.3834, 100.0246],
  "อุบลราชธานี": [15.2442, 104.8473],
  "อ่างทอง": [14.5896, 100.4550],
  "พะเยา": [19.1885, 99.8789]
};

export default provinceCoordinates;
